module.exports = __webpack_public_path__ + "index/img/tousu.78786617.png";